import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const lookupService = {
    getCompanies,
    getDepartments,
    getCandidateJobs,
    getPanelTypes,
    getLocations,
};

const MODULE = {
    COMPANY: 'companies',
    DEPARTMENT: 'departments',
    CANDIDATE_JOB: 'candidate-jobs',
    LOCATION: 'locations',
    PANEL_TYPE: 'panel-types',
};

const API_URL = API.BASE_URL_API + '/v1/fe';

export function getCompanies () {
    return apiHelper(API_URL).get(`/lookup/${MODULE.COMPANY}`);
}

export function getDepartments () {
    return apiHelper(API_URL).get(`/lookup/${MODULE.DEPARTMENT}`);
}

export function getCandidateJobs () {
    return apiHelper(API_URL).get(`/lookup/${MODULE.CANDIDATE_JOB}`);
}

export function getLocations() {
    return apiHelper(API_URL).get(`/lookup/${MODULE.LOCATION}`);
}

export function getPanelTypes () {
    return apiHelper(API_URL).get(`/lookup/${MODULE.PANEL_TYPE}`);
}
